import { atom, useRecoilState } from 'recoil';

const sidebarReloadState = atom({
  key: 'sidebarReload',
  default: false,
});

export const useSidebar = () => {
  const [sidebarReload, setSidebarReload] = useRecoilState(sidebarReloadState);

  const reload = (): void => {
    return setSidebarReload(true);
  };

  return {
    reload,
    sidebarReload,
    setSidebarReload,
  };
};

export default useSidebar;
